import { REMOVE_PACKAGE_SUCCESS } from '../../types/packages';

export default function removePackage(packageId) {
    return async dispatch => {
        dispatch({ type: REMOVE_PACKAGE_SUCCESS, packageId });
    }
}